exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ .completer-input {\n  height: 36px !important;\n  border: 1px solid #E9EBEC !important;\n  display: block !important;\n  -ms-flex: 1 !important;\n      flex: 1 !important;\n  padding: 14px 8px !important;\n  color: #999 !important;\n  width: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/form/address-commerce-form/address-commerce-form.component.scss
// module id = 923
// module chunks = 0